import { ProduktionsomradeDetailDTO } from "~app/common/models/produktionsomrade/ProduktionsomradeDetailDTO";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { ValidationContext } from "~app/common/validation/validationContext";
import { ProduktionsomradeTexts } from "../produktionsomrade.texts";

export class ProduktionsomradeDetailValidation {
    static init(produktionsomrade: ProduktionsomradeDetailDTO): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.spara).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (newValue) =>
                    ObjectUtils.isNullOrUndefined(newValue) ||
                    ObjectUtils.isNullOrUndefined(produktionsomrade.granOvre) ||
                    newValue < produktionsomrade.granOvre,
                message: { text: ProduktionsomradeTexts.validation.granNedre },
                model: () => produktionsomrade.granNedre,
                name: "granNedre",
                verbose: true,
                publish: true,
                subscriptions: ["granOvre"]
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (newValue) =>
                    ObjectUtils.isNullOrUndefined(newValue) ||
                    ObjectUtils.isNullOrUndefined(produktionsomrade.granNedre) ||
                    newValue > produktionsomrade.granNedre,
                message: { text: ProduktionsomradeTexts.validation.granOvre },
                model: () => produktionsomrade.granOvre,
                name: "granOvre",
                verbose: true,
                publish: true,
                subscriptions: ["granNedre"]
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (newValue) =>
                    ObjectUtils.isNullOrUndefined(newValue) ||
                    ObjectUtils.isNullOrUndefined(produktionsomrade.tallOvre) ||
                    newValue < produktionsomrade.tallOvre,
                message: { text: ProduktionsomradeTexts.validation.tallNedre },
                model: () => produktionsomrade.tallNedre,
                name: "tallNedre",
                verbose: true,
                publish: true,
                subscriptions: ["tallOvre"]
            },
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (newValue) =>
                    ObjectUtils.isNullOrUndefined(newValue) ||
                    ObjectUtils.isNullOrUndefined(produktionsomrade.tallNedre) ||
                    newValue > produktionsomrade.tallNedre,
                message: { text: ProduktionsomradeTexts.validation.tallOvre },
                model: () => produktionsomrade.tallOvre,
                name: "tallOvre",
                verbose: true,
                publish: true,
                subscriptions: ["tallNedre"]
            }
        ]);

        return context;
    }
}
